import { Check, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useMapStore } from '@/store/mapStore';
import { KOSHER_FILTER_OPTIONS, KOSHER_AUTHORITIES } from '@/lib/kosherLabels';
import { CATEGORIES } from '@/types/places';
import { Button } from '@/components/ui/button';

export const SearchFilters = () => {
  const {
    activeCategories,
    toggleCategory,
    activeKosherStatuses,
    toggleKosherStatus,
    activeKosherAuthorities,
    toggleKosherAuthority,
    resetFilters,
  } = useMapStore();

  const hasActiveFilters = activeCategories.length > 0 || activeKosherStatuses.length > 0 || activeKosherAuthorities.length > 0;
  const activeFiltersCount = activeCategories.length + activeKosherStatuses.length + activeKosherAuthorities.length;

  return (
    <div className="p-3 space-y-4 border-t border-border">
      {/* Header with reset */}
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-muted-foreground">
          Filtres {activeFiltersCount > 0 && `(${activeFiltersCount})`}
        </span>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={resetFilters}
            className="h-auto py-1 px-2 text-xs text-muted-foreground hover:text-foreground"
          >
            <X className="w-3 h-3 mr-1" />
            Effacer tout
          </Button>
        )}
      </div>

      {/* Categories - Multi-select */}
      <div>
        <h4 className="text-xs font-medium text-muted-foreground mb-2">
          Catégories
          {activeCategories.length > 0 && (
            <span className="ml-1 text-primary">({activeCategories.length})</span>
          )}
        </h4>
        <div className="flex flex-wrap gap-1.5">
          {CATEGORIES.map((category) => {
            const isActive = activeCategories.includes(category.id);
            return (
              <button
                key={category.id}
                onClick={() => toggleCategory(category.id)}
                className={cn(
                  'px-2.5 py-1.5 rounded-full text-xs font-medium transition-all flex items-center gap-1.5',
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80'
                )}
              >
                <span>{category.icon}</span>
                <span>{category.name}</span>
                {isActive && <Check className="w-3 h-3" />}
              </button>
            );
          })}
        </div>
      </div>

      {/* Kosher Status - Multi-select */}
      <div>
        <h4 className="text-xs font-medium text-muted-foreground mb-2">
          Type de cacherout
          {activeKosherStatuses.length > 0 && (
            <span className="ml-1 text-primary">({activeKosherStatuses.length})</span>
          )}
        </h4>
        <div className="flex flex-wrap gap-1.5">
          {KOSHER_FILTER_OPTIONS.map((option) => {
            const isActive = activeKosherStatuses.includes(option.value);
            return (
              <button
                key={option.value}
                onClick={() => toggleKosherStatus(option.value)}
                className={cn(
                  'px-2.5 py-1.5 rounded-full text-xs font-medium transition-all flex items-center gap-1',
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80'
                )}
              >
                <span>{option.label}</span>
                {isActive && <Check className="w-3 h-3" />}
              </button>
            );
          })}
        </div>
      </div>

      {/* Kosher Authorities - Multi-select */}
      <div>
        <h4 className="text-xs font-medium text-muted-foreground mb-2">
          Autorité rabbinique
          {activeKosherAuthorities.length > 0 && (
            <span className="ml-1 text-primary">({activeKosherAuthorities.length})</span>
          )}
        </h4>
        <div className="flex flex-wrap gap-1.5">
          {KOSHER_AUTHORITIES.map((authority) => {
            const isActive = activeKosherAuthorities.includes(authority.value);
            return (
              <button
                key={authority.value}
                onClick={() => toggleKosherAuthority(authority.value)}
                className={cn(
                  'px-2.5 py-1.5 rounded-full text-xs font-medium transition-all flex items-center gap-1',
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80'
                )}
              >
                <span>{authority.label}</span>
                {isActive && <Check className="w-3 h-3" />}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
